import React, { useState } from 'react';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { useThemeStore } from '../../state/theme';

interface PasswordInputProps {
  name: string;
  label?: string;
  validation?: RegisterOptions<any, string> | undefined;
  formObj?: UseFormReturn<any>;
  showPasswordOption?: boolean;
  isOptional?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  name,
  label = 'Password',
  validation = {
    required: 'Password is required',
    minLength: {
      value: 6,
      message: 'Password must be at least 6 characters',
    },
  },
  formObj,
  showPasswordOption = false,
  isOptional = false,
  disabled = false,
  placeholder = '',
}) => {
  const { isDarkMode } = useThemeStore();
  const { register, formState } = formObj || {};
  const [showPassword, setShowPassword] = useState(false);

  const optionalValidation = isOptional
    ? {
        ...validation,
        required: false,
      }
    : validation;

  return (
    <div>
      <label
        htmlFor={name}
        className={`block text-sm font-medium ${
          isDarkMode ? 'text-gray-300' : 'text-gray-700'
        }`}
      >
        {label}
      </label>
      <div className="relative mt-1">
        <input
          {...(register ? register(name, optionalValidation) : {})}
          type={showPassword ? 'text' : 'password'}
          className={`flex-1 w-full rounded-md px-3 py-2 shadow-sm focus:outline-none ${
            isDarkMode
              ? 'bg-gray-700 border-gray-600 text-gray-100 focus:border-indigo-500 focus:ring-indigo-500'
              : 'border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500'
          }`}
          disabled={disabled}
          placeholder={placeholder}
        />
      </div>
      {formState?.errors[name] && (
        <p className="mt-1 text-sm text-red-600">
          {formState?.errors[name]?.message as string}
        </p>
      )}
      {!disabled && showPasswordOption && (
        <div className="flex items-center gap-2 mt-3">
          <input
            id={`show-${name}`}
            type="checkbox"
            checked={showPassword}
            onChange={() => setShowPassword(!showPassword)}
          />
          <label
            htmlFor={`show-${name}`}
            className={`text-sm ${isDarkMode ? 'text-white' : 'text-black'}`}
          >
            Show password
          </label>
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
